import MD5 from "md5.js";

const VERIFY_KEY_SALT = "hemeixc";

function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}

export function dataToVerifyKey(params) {
  if (!isObject(params)) {
    return new MD5().update(VERIFY_KEY_SALT).digest("hex");
  }

  const source = Object.keys(params)
    .sort()
    .map((key) => `${params[key]}`)
    .join("");

  return new MD5().update(source + VERIFY_KEY_SALT).digest("hex");
}



// WEBPACK FOOTER //
// ./src/utils/verifyKey.js